import { fetchAll } from '@/api/supGroup';
import { toTree } from '@/utils/tree';
import types from '../types';

const state = {
  allSupGroups: [],
  supGroups: [],
  supGroupTree: []
};

const mutations = {
  [types.SET_ALLSUPGROUPS](state, allSupGroups) {
    state.allSupGroups = allSupGroups || [];
  },
  [types.SET_SUPGROUPS](state, supGroups) {
    state.supGroups = supGroups;
    state.supGroupTree = toTree(supGroups);
  },
};

const actions = {
  fetchSupGroups({ commit }) {
    this.tableLoading = true;
    return fetchAll()
      .then(res => {
        const allSupGroups = (res.data.data || [])
          .filter(e => String(e.id) !== '0')
          .map(group => {
            return { ...group, disabled: group.status !== 'enable' };
          });
        const supGroups = allSupGroups.filter(e => e.status !== 'delete');
        commit(types.SET_ALLSUPGROUPS, (allSupGroups || []));
        commit(types.SET_SUPGROUPS, (supGroups || []));
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/supGroup.js